import MUIDataTable from 'mui-datatables'
import React from 'react'
import { Link } from 'react-router-dom'
import Loader from '../../common/Loader'
import axios from 'axios'
import Constant from '../../Constant'
import Swal from 'sweetalert2'

class OnboardingSetting extends React.Component {
  state = {
    formAction: 'add',
    formData: {
      title_en: '',
      title_ar: '',
      description_en: '',
      description_ar: '',
      image_en: null,
      image_ar: null,
    },
    list: [],
    isListLoading: false,
    isSaving: false,
    isEditingOrderNumber: false,
    editingOrderNumberId: null,
  }

  componentDidMount() {
    this.loadData()
  }

  loadData = async () => {
    this.setState({ isListLoading: true })
    let list = await axios.get(Constant.getAPI() + '/onboarding/', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
        country_short_name: `${localStorage.getItem('countryShortName')}`,
      },
    })

    if (list.status === 200 && list.data && list.data.data && list.data.data.length > 0) {
      this.setState(
        {
          list: list.data.data,
          isListLoading: false,
        },
        () => {}
      )
    } else {
      this.setState({
        isListLoading: false,
      })
    }
  }

  handleChange = (event) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [event.target.name]: event.target.value,
      },
    })
  }

  handleChangeImage = (event) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [event.target.name]: event.target.files[0],
      },
    })
  }

  delete = async (id) => {
    await axios
      .delete(Constant.getAPI() + '/onboarding/' + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.statusCode === 200) {
          Swal.fire({
            title: 'Deleted Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })

          this.setState({
            list: this.state.list.filter((item) => item.id !== id),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onSave = async () => {
    this.setState({ isSaving: true })
    const formData = new FormData()
    formData.append('title_en', this.state.formData.title_en)
    formData.append('title_ar', this.state.formData.title_ar)
    formData.append('description_ar', this.state.formData.description_ar)
    formData.append('description_en', this.state.formData.description_en)

    if (this.state.formData.image_ar && typeof this.state.formData.image_ar == 'object') {
      formData.append('image_ar', this.state.formData.image_ar)
    }
    if (this.state.formData.image_en && typeof this.state.formData.image_en == 'object') {
      formData.append('image_en', this.state.formData.image_en)
    }

    var request
    if (this.state.formAction === 'add') {
      request = axios.post(Constant.getAPI() + '/onboarding', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    } else {
      request = axios.put(Constant.getAPI() + '/onboarding/' + this.state.formData.id, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    }

    request
      .then((data) => {
        if (data.status === 200 && data.data) {
          Swal.fire({
            title: this.state.formAction === 'add' ? 'Successfully created.' : 'Successfully updated.',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })

          this.onClear()
          this.loadData()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isSaving: false,
        })
      })
  }

  onEdit = async (id) => {
    const selectedRecord = this.state.list.find((item) => item.id === id)

    if (selectedRecord) {
      this.setState({
        formAction: 'edit',
        formData: {
          id: selectedRecord.id,
          order_no: selectedRecord.order_no,
          title_en: selectedRecord.title_en,
          title_ar: selectedRecord.title_ar,
          description_en: selectedRecord.description_en,
          description_ar: selectedRecord.description_ar,
          image_en: selectedRecord.image_en,
          image_ar: selectedRecord.image_ar,
        },
      })
    }
  }

  onClear = () => {
    this.setState(
      {
        isSaving: false,
        formAction: 'add',
        formData: {
          title_en: '',
          title_ar: '',
          description_en: '',
          description_ar: '',
          image_en: null,
          image_ar: null,
        },
      },
      () => {
        this.image_ar_input.value = null
        this.image_en_input.value = null
      }
    )
  }

  onOrderNumberEdit = (id, order) => {
    this.setState({
      editingOrderNumberId: id,
      editingOrderValue: order,
      isEditingOrderNumber: true,
    })
  }

  onOrderNumberSave = async () => {
    if (this.state.editingOrderNumberId && this.state.editingOrderValue) {
      axios
        .put(
          Constant.getAPI() + '/onboarding/' + this.state.editingOrderNumberId,
          {
            order_no: this.state.editingOrderValue,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          }
        )
        .then((data) => {
          if (data.status === 200 && data.data) {
            let tempList = this.state.list

            tempList.forEach((item) => {
              if (item.id === this.state.editingOrderNumberId) {
                item.order_no = this.state.editingOrderValue
              }
            })

            this.setState({
              list: tempList,
              editingOrderNumberId: null,
              editingOrderValue: null,
              isEditingOrderNumber: false,
            })
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      this.setState({
        editingOrderNumberId: null,
        editingOrderValue: null,
        isEditingOrderNumber: false,
      })
    }
  }

  onOrderNumberChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  render() {
    const columns = [
      {
        name: 'id',
        label: 'id',
        options: {
          filter: false,
          sort: true,
          display: false,
        },
      },
      {
        name: 'order_no',
        label: 'Order No.',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (order, tableMeta) => {
            var id = tableMeta.rowData[0]
            return (
              <div className="form-group">
                <div className="form-group">
                  {this.state.isEditingOrderNumber && this.state.editingOrderNumberId === id ? (
                    <div className="input-group mb-3">
                      <input
                        type="number"
                        name="editingOrderValue"
                        className="form-control form-control-sm p-l-15"
                        style={{ width: '50px' }}
                        onChange={this.onOrderNumberChange}
                        value={this.state.editingOrderValue}
                      />
                      <div className="input-group-append border">
                        <span
                          onClick={this.onOrderNumberSave.bind(this, id)}
                          className="input-group-text d-flex justify-content-center align-items-center shadow-sm"
                        >
                          <i className="f-20 bg-white p-2 icofont icofont-ui-check"></i>
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="input-group mb-3">
                      <div
                        className="form-control p-l-15"
                        style={{ width: '50px' }}
                      >
                        {order}
                      </div>
                      <div className="input-group-append border">
                        <span
                          onClick={this.onOrderNumberEdit.bind(this, id, order)}
                          className="input-group-text d-flex justify-content-center align-items-center shadow-sm"
                        >
                          <i className="f-20 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'title_en',
        label: 'Title English',
        options: { filter: false, sort: true },
      },
      {
        name: 'title_ar',
        label: 'Title Arabic',
        options: { filter: false, sort: true },
      },
      {
        name: 'image_en',
        label: 'Image English',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return (
              <>
                <img
                  src={Constant.getImage() + value}
                  className="img-fluid img-100"
                  alt="img"
                  onError={(event) => {
                    event.currentTarget.src = './assets/images/no_image.png'
                  }}
                />
              </>
            )
          },
        },
      },
      {
        name: 'image_ar',
        label: 'Image Arabic',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return (
              <>
                <img
                  src={Constant.getImage() + value}
                  className="img-fluid img-100"
                  alt="img"
                  onError={(event) => {
                    event.currentTarget.src = './assets/images/no_image.png'
                  }}
                />
              </>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div className="d-flex justify-content-start">
                <div
                  onClick={() => {
                    this.onEdit(id)
                  }}
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom m-r-10"></i>
                </div>
                <div
                  onClick={() => {
                    this.delete(id)
                  }}
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>
                </div>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: false,
      filter: false,
      search: false,
      textLabels: {
        body: {
          noMatch: this.state.isListLoading ? <Loader open={this.state.isListLoading} /> : 'Sorry, No Record Found',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Onboarding screens setting</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to={`/onboard-setting`}>Onboarding screens setting</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">Title English:</label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              value={this.state.formData.title_en}
                              name="title_en"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">Title Arabic:</label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              value={this.state.formData.title_ar}
                              name="title_ar"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">Description English:</label>
                          <div className="col-md-9">
                            <textarea
                              rows={3}
                              className="form-control"
                              value={this.state.formData.description_en}
                              name="description_en"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">Description Arabic:</label>
                          <div className="col-md-9">
                            <textarea
                              rows={3}
                              className="form-control"
                              value={this.state.formData.description_ar}
                              name="description_ar"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-sm-3">Image English:</div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <div>
                                <input
                                  type="file"
                                  id="img"
                                  name="image_en"
                                  accept="image/*"
                                  className="w-100"
                                  onChange={this.handleChangeImage}
                                  ref={(ref) => (this.image_en_input = ref)}
                                />
                              </div>
                              <div style={{ color: 'red' }}>Image height width must be 900 * 1050</div>
                              <div style={{ color: 'red' }}>Image size should not be more then 1 MB</div>
                            </div>
                            {this.state.formData &&
                              this.state.formData.image_en &&
                              (typeof this.state.formData.image_en == 'object' ? (
                                <img
                                  width="250px"
                                  height="200px"
                                  src={URL.createObjectURL(this.state.formData.image_en)}
                                  alt="img"
                                />
                              ) : (
                                <img
                                  width="250px"
                                  height="200px"
                                  src={Constant.getImage() + this.state.formData.image_en}
                                  alt="img"
                                />
                              ))}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-sm-3">Image Arabic:</div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <div>
                                <input
                                  type="file"
                                  id="img"
                                  name="image_ar"
                                  accept="image/*"
                                  className="w-100"
                                  onChange={this.handleChangeImage}
                                  ref={(ref) => (this.image_ar_input = ref)}
                                />
                              </div>
                              <div style={{ color: 'red' }}>Image height width must be 900 * 1050</div>
                              <div style={{ color: 'red' }}>Image size should not be more then 1 MB</div>
                            </div>
                            {this.state.formData &&
                              this.state.formData.image_ar &&
                              (typeof this.state.formData.image_ar == 'object' ? (
                                <img
                                  width="250px"
                                  height="200px"
                                  src={URL.createObjectURL(this.state.formData.image_ar)}
                                  alt="img"
                                />
                              ) : (
                                <img
                                  width="250px"
                                  height="200px"
                                  src={Constant.getImage() + this.state.formData.image_ar}
                                  alt="img"
                                />
                              ))}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="row">
                          <div className="text-right col-6 offset-6">
                            {this.state.isSaving ? (
                              <button
                                className="btn btn-grd-disabled mr-2"
                                disabled
                              >
                                Saving...!
                              </button>
                            ) : (
                              <>
                                <button
                                  onClick={this.onSave}
                                  className="btn hor-grd btn-grd-inverse offset-1"
                                >
                                  <i className="ti-save"></i>
                                  {this.state.formAction === 'add' ? 'Save' : 'Update'}
                                </button>
                                <button
                                  onClick={this.onClear}
                                  className="btn hor-grd btn-grd-inverse m-l-10"
                                >
                                  Clear
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Order wise list</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="dt-responsive table-responsive">
                      <MUIDataTable
                        className="table-responsive"
                        data={this.state.list}
                        columns={columns}
                        options={options}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default OnboardingSetting
